import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {AfterViewInit, Component, ElementRef, Inject, Input, PLATFORM_ID, ViewChild, ViewEncapsulation} from '@angular/core';

declare var $: any;

@Component({
    selector: 'app-flex-tooltip',
    styleUrls: ['./flex-tooltip.component.css'],
    templateUrl: './flex-tooltip.component.html',
    encapsulation: ViewEncapsulation.None
})
export class FlexTooltipComponent implements AfterViewInit {
    @Input('placement')
    public readonly placement: 'top' | 'right' | 'bottom' | 'left' = 'top';
    private readonly platformId: Object;
    @ViewChild('infoToolTip')
    private readonly toolTipDiv: ElementRef;
    @ViewChild('trigger')
    private readonly trigger: ElementRef;

    constructor(@Inject(PLATFORM_ID) platformId: Object, @Inject(DOCUMENT) document: any) {
        this.platformId = platformId;
    }

    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.initializeTooltip();
        }
    }

    private initializeTooltip() {
        $(this.trigger.nativeElement).tooltip({
            html: true,
            title: this.toolTipDiv.nativeElement.innerHTML
        });
    }
}
